import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParentChildsService {

  constructor(public http: HttpClient) { }

  getStudentsByParentId(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Profile/GetStudentsByParentId`);
  }
}
